export default "__VITE_ASSET__DSj3UxVN__"